(() => {
  const init = root => {
    if (root.dataset.gbhcReady) return;
    root.dataset.gbhcReady = 'true';
    const labels = JSON.parse(root.querySelector('[data-gbhc-labels]').textContent);
    const money = new Intl.NumberFormat(root.dataset.locale || 'ko-KR', {style:'currency',currency:root.dataset.currency || 'KRW'});
    const format = cents => money.format(Number(cents) / 100);
    const pickers = [];
    const makePicker = select => {
      const wrapper = document.createElement('div');
      wrapper.className = 'gbhc-picker';
      const label = Array.from(select.labels || [])[0];
      const trigger = document.createElement('button');
      trigger.type = 'button';
      trigger.id = select.id + '-trigger';
      trigger.className = 'gbhc-picker-trigger';
      trigger.setAttribute('aria-haspopup', 'listbox');
      trigger.setAttribute('aria-expanded', 'false');
      const list = document.createElement('div');
      list.className = 'gbhc-picker-list';
      list.id = select.id + '-list';
      list.setAttribute('role', 'listbox');
      list.hidden = true;
      trigger.setAttribute('aria-controls', list.id);
      if (label) {
        label.id = label.id || select.id + '-label';
        label.htmlFor = trigger.id;
        list.setAttribute('aria-labelledby', label.id);
        trigger.setAttribute('aria-labelledby', label.id + ' ' + trigger.id + '-value');
      }
      const renderChoice = option => {
        const row = document.createElement('span');
        row.className = 'gbhc-picker-row';
        if (option.dataset.image) {
          const image = document.createElement('img');
          image.src = option.dataset.image;
          image.alt = '';
          image.width = 60;
          image.height = 60;
          image.loading = 'lazy';
          row.append(image);
        }
        const info = document.createElement('span');
        info.className = 'gbhc-picker-info';
        const name = document.createElement('span');
        name.className = 'gbhc-picker-name';
        name.textContent = option.dataset.title || option.textContent;
        info.append(name);
        if (option.value) {
          const price = document.createElement('strong');
          price.className = 'gbhc-picker-price';
          price.textContent = format(option.dataset.price);
          info.append(price);
          if (option.dataset.available !== 'true') {
            const stock = document.createElement('span');
            stock.className = 'gbhc-picker-stock';
            stock.textContent = labels.sold_out;
            info.append(stock);
          }
        }
        row.append(info);
        return row;
      };
      const options = Array.from(select.options);
      const buttons = options.map((option, index) => {
        const item = document.createElement('button');
        item.type = 'button';
        item.className = 'gbhc-picker-option';
        item.setAttribute('role', 'option');
        item.id = list.id + '-' + index;
        item.append(renderChoice(option));
        item.addEventListener('click', () => {
          if (select.disabled) return;
          select.value = option.value;
          select.dispatchEvent(new Event('change', {bubbles: true}));
          close(true);
        });
        list.append(item);
        return item;
      });
      const close = (restoreFocus = false) => {
        list.hidden = true;
        trigger.setAttribute('aria-expanded', 'false');
        if (restoreFocus && !trigger.disabled) trigger.focus({preventScroll: true});
      };
      const focusOption = index => {
        const item = buttons[index];
        if (!item) return;
        buttons.forEach(button => button.tabIndex = button === item ? 0 : -1);
        item.focus({preventScroll: true});
        const top = item.offsetTop;
        if (top < list.scrollTop) list.scrollTop = top;
        else if (top + item.offsetHeight > list.scrollTop + list.clientHeight) list.scrollTop = top + item.offsetHeight - list.clientHeight;
      };
      const open = () => {
        if (select.disabled || !buttons.length) return;
        pickers.forEach(picker => picker.close());
        list.hidden = false;
        trigger.setAttribute('aria-expanded', 'true');
        focusOption(Math.max(0, select.selectedIndex));
      };
      const sync = () => {
        const selected = select.selectedOptions[0];
        trigger.disabled = select.disabled;
        if (selected && trigger.dataset.value !== select.value) {
          const row = renderChoice(selected);
          row.id = trigger.id + '-value';
          trigger.replaceChildren(row);
          trigger.dataset.value = select.value;
        }
        buttons.forEach((item, index) => {
          item.setAttribute('aria-selected', String(index === select.selectedIndex));
          item.tabIndex = index === select.selectedIndex ? 0 : -1;
          item.disabled = select.disabled || options[index].disabled;
        });
        if (select.disabled) close();
      };
      trigger.addEventListener('click', () => list.hidden ? open() : close());
      trigger.addEventListener('keydown', event => {
        if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {event.preventDefault();open();}
      });
      list.addEventListener('keydown', event => {
        const index = buttons.indexOf(document.activeElement);
        let nextIndex = index;
        if (event.key === 'ArrowDown') nextIndex = Math.min(buttons.length - 1, index + 1);
        else if (event.key === 'ArrowUp') nextIndex = Math.max(0, index - 1);
        else if (event.key === 'Home') nextIndex = 0;
        else if (event.key === 'End') nextIndex = buttons.length - 1;
        else if (event.key === 'Escape') {event.preventDefault();event.stopPropagation();close(true);return;}
        else return;
        event.preventDefault();
        focusOption(nextIndex);
      });
      wrapper.addEventListener('focusout', event => {
        if (!wrapper.contains(event.relatedTarget)) close();
      });
      wrapper.append(trigger, list);
      select.after(wrapper);
      select.hidden = true;
      const picker = {wrapper, sync, close};
      pickers.push(picker);
      sync();
      return picker;
    };
    const closeOutside = event => {
      if (!root.isConnected) {document.removeEventListener('pointerdown', closeOutside);return;}
      pickers.forEach(picker => {if (!picker.wrapper.contains(event.target)) picker.close();});
    };
    document.addEventListener('pointerdown', closeOutside);
    const track = root.querySelector('.gbhc-track');
    const previous = root.querySelector('[data-gbhc-prev]');
    const next = root.querySelector('[data-gbhc-next]');
    const syncArrows = () => {previous.disabled=track.scrollLeft<4;next.disabled=track.scrollLeft+track.clientWidth>=track.scrollWidth-4;};
    const slide = direction => {const card=track.querySelector('.gbhc-card');if(card)track.scrollBy({left:direction*(card.getBoundingClientRect().width+parseFloat(getComputedStyle(track).columnGap)),behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});};
    previous.addEventListener('click',()=>slide(-1));next.addEventListener('click',()=>slide(1));
    track.addEventListener('scroll',syncArrows,{passive:true});new ResizeObserver(syncArrows).observe(track);syncArrows();
    let submitting=false;
    const cards=Array.from(root.querySelectorAll('[data-gbhc-card]'));
    const views=cards.map(card=>{
      const selects=Object.fromEntries(Array.from(card.querySelectorAll('[data-gbhc-select]')).map(s=>[s.dataset.gbhcSelect,s]));
      Object.values(selects).forEach(s=>{if(s.dataset.default && Array.from(s.options).some(o=>o.value===s.dataset.default))s.value=s.dataset.default;});
      const cardPickers = Object.values(selects).map(makePicker);
      card.classList.add('gbhc-rich-options');
      const toggle=card.querySelector('[data-gbhc-device-toggle]');
      const button=card.querySelector('[data-gbhc-add]');
      const message=card.querySelector('[data-gbhc-message]');
      let uncertain=false;
      const selected = () => ['device','first','second','extra'].filter(k=>k!=='device'||toggle.checked).map(k=>selects[k].selectedOptions[0]).filter(o=>o&&o.value);
      const update = () => {
        const choices=selected();
        card.querySelector('[data-gbhc-total]').textContent=format(choices.reduce((sum,o)=>sum+Number(o.dataset.price||0),0));
        card.querySelector('[data-gbhc-inclusion]').textContent=toggle.checked?labels.device_included:labels.device_excluded;
        ['first','second'].forEach(k=>{const o=selects[k].selectedOptions[0];if(!o)return;const image=card.querySelector(`[data-gbhc-preview="${k}"] img`);if(image&&o.dataset.image){image.src=o.dataset.image;image.removeAttribute('srcset');image.alt=o.dataset.title;}const link=card.querySelector(`[data-gbhc-link="${k}"]`);link.textContent=o.dataset.title;link.href=o.dataset.url;card.querySelector(`[data-gbhc-price="${k}"]`).textContent=format(o.dataset.price);});
        const device=selects.device.selectedOptions[0];const deviceImage=card.querySelector('.gbhc-lune-image');if(device&&deviceImage&&device.dataset.image){deviceImage.src=device.dataset.image;deviceImage.removeAttribute('srcset');deviceImage.alt=device.dataset.title;}
        const extra=selects.extra.selectedOptions[0];const preview=card.querySelector('[data-gbhc-extra-preview]');preview.hidden=!extra?.value;if(extra?.value){const image=preview.querySelector('img');image.src=extra.dataset.image;image.alt=extra.dataset.title;preview.querySelector('span').textContent=extra.dataset.title+' · '+format(extra.dataset.price);}
        const unavailable=choices.filter(o=>o.dataset.available!=='true');
        const incomplete=!selects.first.value||!selects.second.value||(toggle.checked&&!selects.device.value);
        card.querySelector('[data-gbhc-stock]').textContent=incomplete?labels.unavailable:unavailable.length?unavailable.map(o=>o.dataset.title).join(', ')+' — '+labels.stock_note:'';
        button.disabled=submitting||uncertain||incomplete||unavailable.length>0;
        button.textContent=submitting?labels.adding:incomplete||unavailable.length?labels.sold_out:labels.add;
        Object.values(selects).forEach(s=>s.disabled=submitting);selects.device.disabled=submitting||!toggle.checked;toggle.disabled=submitting;
        cardPickers.forEach(picker => picker.sync());
      };
      Object.values(selects).forEach(s=>s.addEventListener('change',()=>{if(!uncertain)message.textContent='';update();}));toggle.addEventListener('change',()=>{if(!uncertain)message.textContent='';update();});
      button.addEventListener('click',async()=>{
        if(button.disabled||submitting)return;
        const quantities=new Map();selected().forEach(o=>quantities.set(o.value,(quantities.get(o.value)||0)+1));
        const items=Array.from(quantities,([id,quantity])=>({id:Number(id),quantity}));
        submitting=true;views.forEach(v=>v.update());message.textContent='';
        try{
          const response=await fetch(root.dataset.addUrl,{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items})});
          const result=await response.json();
          if(!response.ok){message.textContent=typeof result.description==='string'?result.description:labels.error;card.querySelector('[data-gbhc-cart]').hidden=false;return;}
          uncertain=true;message.textContent=labels.ready;card.querySelector('[data-gbhc-cart]').hidden=false;window.location.assign(root.dataset.cartUrl);
        }catch(error){uncertain=true;message.textContent=labels.network;card.querySelector('[data-gbhc-cart]').hidden=false;}
        finally{submitting=false;views.forEach(v=>v.update());}
      });
      update();return {update};
    });
  };
  document.querySelectorAll('[data-gbhc]').forEach(init);
  if(!window.gripbHomeCombosBound){window.gripbHomeCombosBound=true;document.addEventListener('shopify:section:load',event=>event.target.querySelectorAll('[data-gbhc]').forEach(init));}
})();

